<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css">


<div class="prijavnica">

  <script src="https://www.google.com/recaptcha/api.js" async defer></script>
  <script>
    // mora biti globalno da Angular može pozvati
    window.recaptchaOnload = function () { /* noop – renderat ćemo iz komponente */ };
  </script>
  <header class="site-header">
    <a href="https://www.hep.hr/" target="_blank" class="logo-link">
      <img src="assets/img/bijeliHepLogo.svg" alt="HEP logo" class="logo">
    </a>


    <nav class="nav-links" *ngIf="postsService.natjecaj">
      <a *ngIf="postsService.natjecaj.natjecajDocLink" [href]="postsService.natjecaj.natjecajDocLink" class="mob"
        target="_blank">
        o natječaju
      </a>

      <span *ngIf="postsService.natjecaj.natjecajDocLink
              && postsService.natjecaj.natjecajUputeLink" style="color: #c62828;">|</span>

      <a *ngIf="postsService.natjecaj.natjecajUputeLink" [href]="postsService.natjecaj.natjecajUputeLink" class="mob"
        target="_blank">
        upute
      </a>
      <span *ngIf="postsService.natjecaj.natjecajUputeLink
              && postsService.natjecaj.natjecajFaqLink" style="color: #c62828;">|</span>
      <a *ngIf="postsService.natjecaj.natjecajFaqLink" [href]="postsService.natjecaj.natjecajFaqLink" class="mob"
        target="_blank">
        pitanja
      </a>
    </nav>


  </header>


  <div *ngIf="show" class="page-container">

    <div class="form-container ">



      <!--
            <section class="header-apply">
            </section> -->
      <!-- <div class="logo-wrapper">
                <img src="assets/img/HEP-donacije-logo.png" alt="Donacije logo">
            </div> -->

      <div class="prijavnica-apply" style="margin-top:15%">
        <p style="margin-top: 30px;font-size: 30px;color: rgb(15, 78, 130);font-weight: bold;text-align: center;">
        <div class="prvi-container">
          <p style="margin-top: 30px;font-size: 30px;color: #505052 !important;text-align: center;">
            <!-- Prijava na natječaj za dodjelu donacija u 2026. godini -->
           Prijava na {{postsService.natjecaj!.tekst}}
            <!-- Prijava na natječaj za dodjelu donacija u {{natjecaj?.godina}}. godini -->
          </p>


          <div class="progress-train-wrapper">
            <!-- Hamburger ikona -->
            <div class="hamburger-icon" (click)="toggleTrainMenu()">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div class="progress-train">
              <div *ngFor="let step of steps; let i = index" class="progress-train-step">
                <div class="train-line" *ngIf="i > 0" [class.completed]="i < currentStep-1"></div>

                <div (click)="onStepClick(i+1)" class="train-circle" [class.active]="i < currentStep"
                  [class.completed]="i < currentStep-1">
                  <!-- [class.disabled]="nextStepValidate(i+1) !== (i+1) -->

                  {{ i + 1 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="fixed-timer">
      Preostalo vrijeme: {{ timeRemaining }}
    </div> -->
        <div *ngIf="!prijavnicaForm" class="spinner-overlay">
          <div class="spinner"></div>
        </div>
        <form *ngIf="prijavnicaForm" [formGroup]="prijavnicaForm">
          <!-- <p style="text-align: center;  font-size: 15px;color: #020202;font-weight: lighter;">
                            <strong style="font-weight:bold">Napomena:</strong> polja označena sa zvjezdicom (*) su obvezna.

                        </p> -->
          <div class="col">
            <span class="responsive-space"></span>
          </div>
          <!-- PRVA STRANICA -->

          <div class="grid-form " style="width: 100%; height:auto ">

            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

            <div *ngIf="currentStep === 1" @flyInOut>
              <!-- <p style="font-size: 20px;color: rgb(15, 78, 130);font-weight: bold;text-align: center;">Prihvaćamo isključivo ovaj elektronički popunjeni obrazac.</p> -->
              <!-- <p style=" text-align: center;  font-size: 15px;color: #020202;font-weight: lighter;"><strong style="font-weight:bold">Napomena:</strong> polja označena sa zvjezdicom (*) su obvezna. Nije moguć upis
                                <> # [] | znakova.
                            </p> -->
              <div class="form-check-wrapper">


                <div>

                  <!-- <label style="width: 200px;margin-bottom: 23px;margin-left:33%">Područje prijave* : </label> -->


                  <h2 class="my-lab" style="   font-size: 1.7em !important; color: #4c7bc1  ; ">Područje prijave* </h2>



                  <!-- //novo -->

                  <!-- <div class="form-check-item" style="height: 50px; width: 500px; margin-left: 230px;
                                          border-radius: 8px; padding-left: 15px; padding-bottom: 10px;"
                              *ngFor="let podrucje of podrucjaPrijave; let i = index" class="form-check-item"> -->


                  <div class="form-check-item centered-list" *ngFor="let podrucje of podrucjaPrijave; let i = index">

                    <!-- Radio button -->
                    <label class="container">
                      <input type="radio" formControlName="idPodr" [value]="podrucje?.idPodr" name="idPodr"
                        (change)="onRadioChange(podrucje.idPodr)">
                      <div style="font-weight: lighter;margin-top: 3px;"> {{podrucje?.kategorija}}</div>
                      <span class="checkmark"></span>
                    </label>
                  </div>

                  <!-- //ENDNOVO -->







                </div>
                <br>
                <p style="font-size: 12px;color: red ;font-weight: lighter;text-align: left;">{{podrPrijaveError}}

                </p>

                <br>

              </div>
              <!-- RAZMAK red 5 br-->
              <div class="row">
                <div class="my-div">
                  <span></span>
                </div>
              </div>
              <div style="text-align: right;">
                <button type="button" (click)="nextStep()">Dalje</button>
              </div>
            </div>
          </div>
          <!-- DRUGA STRANICA -->
          <div class="grid-form " style=" width: 100%;height:auto;">

            <div *ngIf="currentStep === 2" @flyInOut>

              <h2 style="   font-size: 1.7em !important; color: #4c7bc1  ; ">Podaci o prijavitelju </h2>
              <!-- PRVI RED -->
              <div class="row">
                <div class="col">
                  <span class="responsive-col"></span>
                </div>
              </div>
              <div class="row">
                <!-- PRVA kolona  -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagOib">OIB*</label>
                  <input id="predlagOib" type="text" inputmode="numeric" class="form-control italic-placeholder w-100"
                    formControlName="predlagOib" [placeholder]="prijavnicaForm.get('predlagOib')?.hasError('required') && prijavnicaForm.get('predlagOib')?.touched
      ? 'Polje je obvezno'
      : 'Unesite OIB'" [ngClass]="{
      'invalid-inputoib': (prijavnicaForm.get('predlagOib')?.hasError('invalidOib') && prijavnicaForm.get('predlagOib')?.touched) ||
                         (prijavnicaForm.get('predlagOib')?.hasError('required') && prijavnicaForm.get('predlagOib')?.touched),
      'invalid-input': prijavnicaForm.get('predlagOib')?.hasError('oibExists') && prijavnicaForm.get('predlagOib')?.touched,
      'valid-placeholder': prijavnicaForm.get('predlagOib')?.valid,
      'invalid-placeholder': prijavnicaForm.get('predlagOib')?.hasError('required') && prijavnicaForm.get('predlagOib')?.touched
    }" pattern="[0-9]*" maxlength="11" (input)="onOibChange()" (keydown)="blockInvalidCharacters($event)"
                    (paste)="onPasteOib($event)" />

                  <div
                    *ngIf="prijavnicaForm.get('predlagOib')?.hasError('invalidOib') && prijavnicaForm.get('predlagOib')?.touched"
                    class="error-message" style="margin-left:10px;">
                    OIB mora imati točno 11 znamenki.
                  </div>

                  <div
                    *ngIf="prijavnicaForm.get('predlagOib')?.hasError('oibExists') && prijavnicaForm.get('predlagOib')?.touched"
                    class="error-message" style="margin-left:10px;">
                    {{ oibError }}
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for="predlagNaziv">
                    Naziv*
                    <span style="font-weight: lighter; font-size: smaller;">
                      (maksimalno 200 znakova s razmacima)
                    </span>
                  </label>

                  <input id="predlagNaziv" type="text" class="form-control italic-placeholder w-100"
                    title="Koristite ime UDRUGE / KLUBA / USTANOVE kao što je navedeno u registru kojeg prilažete uz prijavu."
                    [placeholder]="
      prijavnicaForm.get('predlagNaziv')?.invalid &&
      prijavnicaForm.get('predlagNaziv')?.touched
        ? 'Polje je obvezno'
        : 'Unesite naziv subjekta'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagNaziv')?.invalid &&
        prijavnicaForm.get('predlagNaziv')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagNaziv')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagNaziv')?.invalid &&
        prijavnicaForm.get('predlagNaziv')?.touched
    }" formControlName="predlagNaziv" maxlength="200" (input)="updateCharacterCount()" />

                  <div class="character-count">
                    <span>{{ remainingCharacters }} / 200 znakova</span>
                  </div>
                </div>
                <!-- Loading spinner – vidi se samo dok je isLoadingGrad = true -->
                <div *ngIf="isLoadingOib" class="position-absolute end-0 top-50 translate-middle-y me-3">
                  <div class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="visually-hidden">Učitavanje...</span>
                  </div>
                </div>

              </div>

              <!-- TREĆI RED -->
              <div class="row">
                <!-- TREĆI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagUlica">Ulica i broj*</label>
                  <input id="predlagUlica" type="text" class="form-control italic-placeholder w-100" [placeholder]="
      prijavnicaForm.get('predlagUlica')?.invalid &&
      prijavnicaForm.get('predlagUlica')?.touched
        ? 'Polje je obvezno'
        : 'Unesite ulicu i kućni broj'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagUlica')?.invalid &&
        prijavnicaForm.get('predlagUlica')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagUlica')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagUlica')?.invalid &&
        prijavnicaForm.get('predlagUlica')?.touched
    }" formControlName="predlagUlica" />

                  <!-- Ako želiš, možeš vratiti error poruku -->
                  <!--
  <div
    *ngIf="
      prijavnicaForm.get('predlagUlica')?.invalid &&
      prijavnicaForm.get('predlagUlica')?.touched
    "
    class="error-message"
    style="margin-left: 10px;"
  >
    Polje je obvezno.
  </div>
  -->
                </div>

                <!-- TREĆI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagPtBr">Poštanski broj*</label>

                  <input id="predlagPtBr" type="text" inputmode="numeric" class="form-control italic-placeholder w-100"
                    [placeholder]="
      prijavnicaForm.get('predlagPtBr')?.invalid &&
      prijavnicaForm.get('predlagPtBr')?.touched
        ? 'Polje je obvezno'
        : 'Unesite poštanski broj'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagPtBr')?.invalid &&
        prijavnicaForm.get('predlagPtBr')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagPtBr')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagPtBr')?.invalid &&
        prijavnicaForm.get('predlagPtBr')?.touched
    }" formControlName="predlagPtBr" minlength="5" maxlength="5" pattern="[0-9]*" (input)="limitInputLength($event, 5)"
                    (keydown)="blockInvalidCharacters($event)" />

                  <div *ngIf="
      prijavnicaForm.get('predlagPtBr')?.invalid &&
      prijavnicaForm.get('predlagPtBr')?.touched
    " class="error-message" style="margin-left: 10px;">
                    Poštanski broj mora imati točno 5 znamenki.
                  </div>
                </div>

              </div>
              <!-- ČETVRTI RED -->
              <div class="row">
                <!-- ČETVRTI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagGrad">Grad/mjesto*</label>

                  <input id="predlagGrad" type="text" class="form-control italic-placeholder w-100"
                    (keydown)="blockInvalidCharactersBrojevi($event)" [placeholder]="
      prijavnicaForm.get('predlagGrad')?.invalid &&
      prijavnicaForm.get('predlagGrad')?.touched
        ? 'Polje je obvezno'
        : 'Unesite naziv grada/mjesta'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagGrad')?.invalid &&
        prijavnicaForm.get('predlagGrad')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagGrad')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagGrad')?.invalid &&
        prijavnicaForm.get('predlagGrad')?.touched
    }" formControlName="predlagGrad" />

                  <!-- Loading spinner – vidi se samo dok je isLoadingGrad = true -->
                  <div *ngIf="isLoadingGrad" class="position-absolute end-0 top-50 translate-middle-y me-3">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                      <span class="visually-hidden">Učitavanje...</span>
                    </div>
                  </div>

                  <!-- Ako želiš prikaz poruke o grešci -->
                  <!--
  <div
    *ngIf="
      prijavnicaForm.get('predlagGrad')?.invalid &&
      prijavnicaForm.get('predlagGrad')?.touched
    "
    class="error-message"
    style="margin-left: 10px;"
  >
    Polje je obvezno.
  </div>
  -->
                </div>

                <!-- ČETVRTI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagZupanijaId">Županija*</label>
                  <select id="predlagZupanijaId" formControlName="predlagZupanijaId" class="form-control"  (change)="onZupanijaSelect($event)"
                    [ngClass]="{'invalid-input': prijavnicaForm.get('predlagZupanijaId')?.hasError('required') && prijavnicaForm.get('predlagZupanijaId')?.touched}">
                    <option value="" disabled selected>Odaberite županiju...</option>
                    <option *ngFor="let zupanija of zupanije" [value]="zupanija.id">
                      {{ zupanija.naziv }}
                    </option>


                  </select>
                  <!-- <div *ngIf="prijavnicaForm.get('predlagZupanija')?.invalid && prijavnicaForm.get('predlagZupanija')?.touched" class="error-message" style="margin-left: 10px;">
                                Polje je obvezno.
                            </div> -->
                </div>
              </div>
              <!-- Peti RED -->
              <div class="row">
                <!-- PRVA kolona  -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagMatReg">
                    Matični registar*
                    <span style="font-weight: lighter; font-size: smaller;">
                      (naziv i registarski broj)
                    </span>
                  </label>

                  <input id="predlagMatReg" type="text" class="form-control italic-placeholder w-100" [placeholder]="
      prijavnicaForm.get('predlagMatReg')?.invalid &&
      prijavnicaForm.get('predlagMatReg')?.touched
        ? 'Polje je obvezno'
        : 'Unesite naziv i registarski broj matičnog registra'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagMatReg')?.invalid &&
        prijavnicaForm.get('predlagMatReg')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagMatReg')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagMatReg')?.invalid &&
        prijavnicaForm.get('predlagMatReg')?.touched
    }" formControlName="predlagMatReg" />

                  <!-- Ako želiš, možeš vratiti poruku o grešci -->
                  <!--
  <div
    *ngIf="
      prijavnicaForm.get('predlagMatReg')?.invalid &&
      prijavnicaForm.get('predlagMatReg')?.touched
    "
    class="error-message"
    style="margin-left: 10px;"
  >
    Polje je obvezno.
  </div>
  -->
                </div>

                <!-- Peti RED DRUGA kolona  -->
                <div class="col-md-6 col-sm-12">
                  <!-- ŽELIM PRAZNO -->
                </div>
              </div>
              <!-- Šesti RED -->
              <div class="row">
                <!-- Šesti RED, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagIban">IBAN*</label>

                  <input id="predlagIban" type="text" class="form-control italic-placeholder w-100"
                    style="text-transform: uppercase;" maxlength="21" (input)="onIbanChange()" [placeholder]="
      prijavnicaForm.get('predlagIban')?.invalid &&
      prijavnicaForm.get('predlagIban')?.touched
        ? 'Polje je obvezno'
        : 'Unesite IBAN u formatu: HRXXXXXXXXXXXXXXXXXXX'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagIban')?.invalid &&
        prijavnicaForm.get('predlagIban')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagIban')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagIban')?.invalid &&
        prijavnicaForm.get('predlagIban')?.touched
    }" formControlName="predlagIban" />

                  <div *ngIf="
      prijavnicaForm.get('predlagIban')?.invalid &&
      prijavnicaForm.get('predlagIban')?.touched
    " class="error-message" style="margin-left: 10px;">
                    IBAN mora biti ispravnog formata.
                  </div>
                </div>

                <!-- Šesti RED, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagBanka">Otvoren kod banke*</label>

                  <input id="predlagBanka" type="text" class="form-control italic-placeholder w-100"
                    (keydown)="blockInvalidCharactersBrojevi($event)" [placeholder]="
      prijavnicaForm.get('predlagBanka')?.invalid &&
      prijavnicaForm.get('predlagBanka')?.touched
        ? 'Polje je obvezno'
        : 'Unesite naziv banke'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagBanka')?.invalid &&
        prijavnicaForm.get('predlagBanka')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagBanka')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagBanka')?.invalid &&
        prijavnicaForm.get('predlagBanka')?.touched
    }" formControlName="predlagBanka" />

                  <!-- Ako želiš prikazati poruku o grešci -->
                  <!--
  <div
    *ngIf="
      prijavnicaForm.get('predlagBanka')?.invalid &&
      prijavnicaForm.get('predlagBanka')?.touched
    "
    class="error-message"
    style="margin-left: 10px;"
  >
    Polje je obvezno.
  </div>
  -->
                </div>

              </div>
              <!-- Šesti A red, dodani PNB i MODEL-->
              <div class="row">
                <!-- Šesti A RED, prva kolona -->
                <div class="col-md-6 col-sm-12" style="align-items: center;">
                  <label for="predlagModel" class="d-flex align-items-center gap-1">
                    Model i poziv na broj
                    <span class="question-mark" (click)="showInfo = !showInfo" title="Klikni za više informacija">
                      ?
                    </span>

                    <div *ngIf="showInfo" class="tooltip-box">
                      Obvezan podatak samo za one čiji računi su u sastavu riznice grada, općine, županije ili državnog
                      proračuna.
                    </div>
                  </label>

                  <div class="row g-0">
                    <!-- Model -->
                    <div class="col-auto d-flex align-items-center">
                      <div class="hr-model-group">
                        <span class="hr-prefix">HR</span>
                        <input id="predlagModel" type="text" maxlength="6" (keydown)="blockInvalidCharacters($event)"
                          class="form-control italic-placeholder" placeholder="Model" formControlName="predlagModel" />
                      </div>
                    </div>
                    <!-- Poziv na broj -->
                    <div class="col">
                      <input id="predlagPnb" type="text" maxlength="30" (keydown)="blockInvalidCharactersPnb($event)"
                        class="form-control italic-placeholder" style="
          text-transform: uppercase;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        " placeholder="Poziv na broj" formControlName="predlagPnb" />
                    </div>
                  </div>
                </div>



                <!-- Šesti A RED, druga kolona -->

                <div class="col-md-6 col-sm-12">
                </div>

              </div>
              <!-- ŠESTI A RED -->
              <div class="row">

                <!-- ŠESTI A RED, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <span class="responsive-space"></span>
                </div>

                <!-- ŠESTI A red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <span class="responsive-space"></span>
                </div>
              </div>
              <!-- SEDMI RED -->
              <div class="row">
                <!-- SEDMI RED, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagOvlOs">
                    Osoba ovlaštena za zastupanje prijavitelja*
                    <span style="font-weight: lighter; font-size: smaller;">(ime i prezime)</span>
                  </label>

                  <input id="predlagOvlOs" type="text" class="form-control italic-placeholder w-100"
                    (keydown)="blockInvalidCharactersBrojevi($event); onKeyDown($event)" [placeholder]="
      prijavnicaForm.get('predlagOvlOs')?.invalid &&
      prijavnicaForm.get('predlagOvlOs')?.touched
        ? 'Polje je obvezno'
        : 'Unesite ime i prezime osobe ovlaštene za zastupanje'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagOvlOs')?.invalid &&
        prijavnicaForm.get('predlagOvlOs')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagOvlOs')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagOvlOs')?.invalid &&
        prijavnicaForm.get('predlagOvlOs')?.touched
    }" formControlName="predlagOvlOs" />
                </div>

                <!-- SEDMI, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagFjaOvlOs">
                    Funkcija ovlaštene osobe*
                    <span style="font-weight: lighter; font-size: smaller;">
                      (predsjednik, tajnik, ...)
                    </span>
                  </label>

                  <input id="predlagFjaOvlOs" type="text" class="form-control italic-placeholder w-100"
                    (keydown)="blockInvalidCharactersBrojevi($event)" [placeholder]="
      prijavnicaForm.get('predlagFjaOvlOs')?.invalid &&
      prijavnicaForm.get('predlagFjaOvlOs')?.touched
        ? 'Polje je obvezno'
        : 'Unesite funkciju ovlaštene osobe'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagFjaOvlOs')?.invalid &&
        prijavnicaForm.get('predlagFjaOvlOs')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagFjaOvlOs')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagFjaOvlOs')?.invalid &&
        prijavnicaForm.get('predlagFjaOvlOs')?.touched
    }" formControlName="predlagFjaOvlOs" />
                </div>

              </div>
              <!-- OSMI RED -->
              <div class="row">
                <!-- OSMI RED, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagTel">Broj mobitela i/ili telefona*</label>

                  <input id="predlagTel" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="10"
                    class="form-control italic-placeholder w-100" (keydown)="blockInvalidCharacters($event)"
                    [placeholder]="
      prijavnicaForm.get('predlagTel')?.invalid &&
      prijavnicaForm.get('predlagTel')?.touched
        ? 'Polje je obvezno'
        : 'Unesite broj mobitela/telefona'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagTel')?.invalid &&
        prijavnicaForm.get('predlagTel')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagTel')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagTel')?.invalid &&
        prijavnicaForm.get('predlagTel')?.touched
    }" formControlName="predlagTel" />
                </div>

                <!-- OSMI RED, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagEmail">E-mail*</label>

                  <input id="predlagEmail" type="text" class="form-control italic-placeholder w-100 readonly-input"
                    placeholder="Popunjava se automatski" formControlName="predlagEmail" readonly />
                </div>

              </div>
              <!-- DEVETI red -->
              <div class="row">

                <!-- DEVETI red, prva kolona -->


                <!-- DEVETI red, druga kolona -->
                <div class="col">

                </div>
              </div>
              <!-- DESETI red -->
              <div class="row">

                <!-- DESETI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <span class="responsive-space"></span>
                </div>

                <!-- DESETI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <span class="responsive-space"></span>
                </div>
              </div>
              <!-- JEDANAESTI red -->
              <div class="row">
                <!-- JEDANAESTI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagGodOsnut">Godina osnutka*</label>

                  <input id="predlagGodOsnut" type="text" inputmode="numeric" maxlength="4"
                    class="form-control italic-placeholder w-100" (keydown)="blockInvalidCharacters($event)"
                    [placeholder]="
      prijavnicaForm.get('predlagGodOsnut')?.invalid &&
      prijavnicaForm.get('predlagGodOsnut')?.touched
        ? 'Polje je obvezno'
        : 'Unesite godinu osnutka'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagGodOsnut')?.invalid &&
        prijavnicaForm.get('predlagGodOsnut')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagGodOsnut')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagGodOsnut')?.invalid &&
        prijavnicaForm.get('predlagGodOsnut')?.touched
    }" formControlName="predlagGodOsnut" />

                  <div *ngIf="
      prijavnicaForm.get('predlagGodOsnut')?.invalid &&
      prijavnicaForm.get('predlagGodOsnut')?.touched
    " class="error-message" style="margin-left: 10px;">
                    Godina mora biti između 1900 i trenutne godine.
                  </div>
                </div>

                <!-- JEDANAESTI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagCiljOsnivanja">Cilj osnivanja*</label>

                  <input id="predlagCiljOsnivanja" type="text" class="form-control italic-placeholder w-100"
                    [placeholder]="
      prijavnicaForm.get('predlagCiljOsnivanja')?.invalid &&
      prijavnicaForm.get('predlagCiljOsnivanja')?.touched
        ? 'Polje je obvezno'
        : 'Unesite cilj osnivanja pravnog subjekta'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagCiljOsnivanja')?.invalid &&
        prijavnicaForm.get('predlagCiljOsnivanja')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagCiljOsnivanja')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagCiljOsnivanja')?.invalid &&
        prijavnicaForm.get('predlagCiljOsnivanja')?.touched
    }" formControlName="predlagCiljOsnivanja" />
                </div>

              </div>
              <br>

              <!-- DVANAESTI-->

              <div class="row">

                <!-- DVANAESTI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagBrZaposleni">Broj zaposlenih osoba čija se plaća sufinancira sredstvima iz
                    projekta/programa*</label>
                  <input id="predlagBrZaposleni" type="text" inputmode="numeric" maxlength="3"
                    class="form-control italic-placeholder w-100" (keydown)="blockInvalidCharacters($event)"
                    [placeholder]="
      prijavnicaForm.get('predlagBrZaposleni')?.invalid &&
      prijavnicaForm.get('predlagBrZaposleni')?.touched
        ? 'Polje je obvezno'
        : 'Unesite broj zaposlenih osoba'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagBrZaposleni')?.invalid &&
        prijavnicaForm.get('predlagBrZaposleni')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagBrZaposleni')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagBrZaposleni')?.invalid &&
        prijavnicaForm.get('predlagBrZaposleni')?.touched
    }" formControlName="predlagBrZaposleni" />

                </div>

                <!-- DVANAESTI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <div class="col">
                    <span class="responsive-col"></span>
                  </div>

                  <label for="predlagBrVolonteri">Broj volontera uključenih u provedbu projekta/programa*</label>
                  <input id="predlagBrVolonteri" type="text" class="form-control italic-placeholder w-100"
                    inputmode="numeric" pattern="[0-9]*" maxlength="6" (keydown)="blockInvalidCharacters($event)"
                    (input)="limitInputLength($event, 6)" [placeholder]="
      prijavnicaForm.get('predlagBrVolonteri')?.invalid &&
      prijavnicaForm.get('predlagBrVolonteri')?.touched
        ? 'Polje je obvezno'
        : 'Unesite broj volontera uključenih u provedbu projekta/programa'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagBrVolonteri')?.invalid &&
        prijavnicaForm.get('predlagBrVolonteri')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagBrVolonteri')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagBrVolonteri')?.invalid &&
        prijavnicaForm.get('predlagBrVolonteri')?.touched
    }" formControlName="predlagBrVolonteri" />
                </div>

              </div>

              <div class="row">
                <div class="col">
                  <span class="responsive-col"></span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <label for="predlagBrOsobaNak">
                    Ukupan broj osoba koje će primiti naknadu iz sredstava projekta*
                    <span style="font-weight: lighter; font-size: smaller;">
                      (ugovori o djelu, autorski ugovori, studentski ugovori)
                    </span>
                  </label>

                  <input id="predlagBrOsobaNak" type="text" class="form-control italic-placeholder w-100"
                    inputmode="numeric" pattern="[0-9]*" maxlength="6" (keydown)="blockInvalidCharacters($event)"
                    (input)="limitInputLength($event, 6)" [placeholder]="
      prijavnicaForm.get('predlagBrOsobaNak')?.invalid &&
      prijavnicaForm.get('predlagBrOsobaNak')?.touched
        ? 'Polje je obvezno'
        : 'Unesite broj osoba koje će primiti naknadu iz sredstava projekta'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagBrOsobaNak')?.invalid &&
        prijavnicaForm.get('predlagBrOsobaNak')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagBrOsobaNak')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagBrOsobaNak')?.invalid &&
        prijavnicaForm.get('predlagBrOsobaNak')?.touched
    }" formControlName="predlagBrOsobaNak" />

                  <div class="error-message" *ngIf="
      prijavnicaForm.get('predlagBrOsobaNak')?.invalid &&
      prijavnicaForm.get('predlagBrOsobaNak')?.touched
    " style="margin-left: 10px;">
                    Polje je obvezno.
                  </div>
                </div>



                <div class="col-md-6 col-sm-12" style="margin-top: 22px;">
                  <label for="predlagPrihodi">
                    Prihodi u prošloj godini*
                    <span style="font-weight: lighter; font-size: smaller;">(iznos u €)</span>
                  </label>

                  <input id="predlagPrihodi" type="text" style="text-align: right;"
                    class="form-control italic-placeholder w-100" maxlength="15" inputmode="decimal"
                    (keydown)="blockInvalidCharactersSlova($event)"
                    (input)="onInputChangeFields(prijavnicaForm.get('predlagPrihodi')?.value, 'predlagPrihodi')"
                    [placeholder]="
      prijavnicaForm.get('predlagPrihodi')?.invalid &&
      prijavnicaForm.get('predlagPrihodi')?.touched
        ? 'Polje je obvezno'
        : 'Unesite iznos u formatu 0.000.000,00'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('predlagPrihodi')?.invalid &&
        prijavnicaForm.get('predlagPrihodi')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('predlagPrihodi')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('predlagPrihodi')?.invalid &&
        prijavnicaForm.get('predlagPrihodi')?.touched
    }" formControlName="predlagPrihodi" />
                </div>

                <!-- <div class="col">

            </div> -->
              </div>


              <div class="row">
                <div class="col">
                  <span class="responsive-col"></span>
                </div>
              </div>

              <!-- TRINAESTI red -->
              <div class="row">
                <!-- TRINAESTI red, prva kolona -->

                <!-- TRINAESTI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagGodDonacija">Godine dobivenih donacija</label>

                  <input id="predlagGodDonacija" type="text"
                    class="form-control italic-placeholder w-100 readonly-input" placeholder="Popunjava se automatski"
                    formControlName="predlagGodDonacija" readonly />
                </div>
                <div class="col-md-6 col-sm-12">
                </div>
              </div>
              <!-- RAZMAK red 5 br -->
              <div class="row">
                <div class="my-div">
                  <span></span>
                </div>
              </div>
              <!-- ZADNJI red -->
              <div class="row">
                <div>
                  <button type="button" (click)="previousStep()" style="margin-right: 8px;">Nazad</button>
                  <button type="button" (click)="nextStep()" style="float: right;">Dalje</button>
                </div>

              </div>
            </div>
          </div>
          <!-- TREĆA STRANICA -->
          <div class="grid-form" style="width: 100%;height:auto ">
            <div *ngIf="currentStep === 3" @flyInOut>
              <h2 style="   font-size: 1.7em !important; color: #4c7bc1  ; ">Podaci o projektu/programu rada</h2>
              <!-- PRVI RED LABELE -->

              <div class="row">
                <div class="col">
                  <span class="responsive-col"></span>
                </div>
              </div>
              <!--PRVI RED -->
              <div class="row">

                <!-- PRVI red, prva kolona -->
                <div class="col-md-6 col-sm-12">

                  <div>
                    <span class="responsive-col"></span>
                    <label for="projektNaziv">Naziv projekta*
                      <span style="font-weight: lighter;font-size: smaller;"> (maksimalno 200 znakova
                        s
                        razmacima)</span>
                    </label>
                    <input id="projektNaziv" type="text" class="form-control italic-placeholder w-100" maxlength="200"
                      (input)="updateProjectCharacterCount()" [placeholder]="
        prijavnicaForm.get('projektNaziv')?.invalid &&
        prijavnicaForm.get('projektNaziv')?.touched
          ? 'Polje je obvezno'
          : 'Unesite naziv projekta'
      " [ngClass]="{
        'invalid-input':
          prijavnicaForm.get('projektNaziv')?.invalid &&
          prijavnicaForm.get('projektNaziv')?.touched,
        'valid-placeholder':
          prijavnicaForm.get('projektNaziv')?.valid,
        'invalid-placeholder':
          prijavnicaForm.get('projektNaziv')?.invalid &&
          prijavnicaForm.get('projektNaziv')?.touched
      }" formControlName="projektNaziv" />

                    <div class="character-count">
                      <span>{{ projectCurrentCharacterCount }} / 200 znakova</span>
                    </div>
                  </div>

                  <div>
                    <label for="projektGeoPodr">
                      Geografsko područje provedbe *
                      <span style="font-weight: lighter; font-size: smaller;">
                        (npr. općina, grad, županija)
                      </span>
                    </label>

                    <input id="projektGeoPodr" type="text" class="form-control italic-placeholder w-100" [placeholder]="
        prijavnicaForm.get('projektGeoPodr')?.invalid &&
        prijavnicaForm.get('projektGeoPodr')?.touched
          ? 'Polje je obvezno'
          : 'Unesite područje provedbe projekta/programa'
      " [ngClass]="{
        'invalid-input':
          prijavnicaForm.get('projektGeoPodr')?.invalid &&
          prijavnicaForm.get('projektGeoPodr')?.touched,
        'valid-placeholder':
          prijavnicaForm.get('projektGeoPodr')?.valid,
        'invalid-placeholder':
          prijavnicaForm.get('projektGeoPodr')?.invalid &&
          prijavnicaForm.get('projektGeoPodr')?.touched
      }" formControlName="projektGeoPodr" />
                  </div>
                </div>


                <!-- PRVI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="projektOpis">Sažeti opis projekta/programa rada*<span
                      style="font-weight: lighter;font-size: smaller;"> (maksimalno 2000 znakova s razmacima)</span>
                    <!-- <app-info-button  infoText="Ako vam se čini da vaš zahtjev ne prelazi 2000 znakova ali ipak javlja grešku, provjerite sadrži li vaš unos višestruke razmake, nabrajanja i ostala dodatna oblikovanja. Tekst mora biti u čistoj tekstualnoj formi bez dodatnih stilova i oblikovanja (kao što je podebljano, podcrtano, kurziv, boje, eksponent, indeks i ostalo)."></app-info-button> -->
                  </label>
                  <div class="textarea-container">
                    <textarea id="projektOpis" class="italic-placeholder"
                      [ngClass]="{'invalid-textarea': prijavnicaForm.get('projektOpis')?.invalid && prijavnicaForm.get('projektOpis')?.touched}"
                      [placeholder]="prijavnicaForm.get('projektOpis')?.invalid && prijavnicaForm.get('projektOpis')?.touched ? 'Polje je obvezno' : 'Unesite kratki opis projekta'"
                      [ngClass]="{'invalid-textarea': prijavnicaForm.get('projektOpis')?.invalid && prijavnicaForm.get('projektOpis')?.touched,
                        'valid-placeholder': prijavnicaForm.get('projektOpis')?.valid,
                        'invalid-placeholder': prijavnicaForm.get('projektOpis')?.invalid && prijavnicaForm.get('projektOpis')?.touched
                    }" class="form-control" formControlName="projektOpis" maxlength="2000"
                      (input)="updateProjektOpisCharacterCount()">
                </textarea>
                    <div class="character-count">
                      <span>{{ projektOpisCurrentCharacterCount }} / 2000 znakova</span>
                    </div>

                  </div>

                </div>
              </div>
              <!--  red -->
              <div class="row">
                <div class="col">
                  <span class="responsive-col"></span>
                </div>
              </div>
              <!-- DRUGI red -->
              <div class="row">
                <!-- DRUGI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="projektSredstva">
                    Izvor sredstava za provedbu projekta/programa rada*
                    <span style="font-weight: lighter; font-size: smaller;">
                      (npr. donacije, vlastita sredstva, članarine)
                    </span>
                  </label>

                  <input id="projektSredstva" type="text" class="form-control italic-placeholder w-100"
                    (keydown)="blockInvalidCharactersBrojevi($event)" [placeholder]="
      prijavnicaForm.get('projektSredstva')?.invalid &&
      prijavnicaForm.get('projektSredstva')?.touched
        ? 'Polje je obvezno'
        : 'Unesite izvor sredstava za provedbu projekta/programa'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('projektSredstva')?.invalid &&
        prijavnicaForm.get('projektSredstva')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('projektSredstva')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('projektSredstva')?.invalid &&
        prijavnicaForm.get('projektSredstva')?.touched
    }" formControlName="projektSredstva" />
                </div>

                <!-- DRUGI red, druga kolona IIIII-->
                <div class="col-md-6 col-sm-12" style="margin-top: 23px;">
                  <label for="projektIznosHep">Iznos koji se traži od HEP d.d.*<span
                      style="font-weight: lighter;font-size: smaller;  text-align: right;">
                      (minimalno {{ formatNumber(postsService.natjecaj.minIznos) }} - maksimalno {{
                      formatNumber(postsService.natjecaj.maxIznos)
                      }})</span></label>

                  <!-- <input id="projektIznosHep"
              class="italic-placeholder"   placeholder="Unesite iznos u formatu: 0.000,00"
                [ngClass]="{'invalid-input': prijavnicaForm.get('projektIznosHep')?.invalid && prijavnicaForm.get('projektIznosHep')?.touched}"
                (keydown)="blockInvalidCharactersSlova($event)"
                formControlName="projektIznosHep"
                type="text"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
                [dropSpecialCharacters]="false"
                /> -->


                  <input id="projektIznosHep" type="text" style="text-align: right;"
                    class="form-control italic-placeholder w-100" maxlength="15" inputmode="decimal"
                    (keydown)="blockInvalidCharactersSlova($event)"
                    (input)="onInputChangeFields(prijavnicaForm.get('projektIznosHep')?.value, 'projektIznosHep')"
                    [placeholder]="
      prijavnicaForm.get('projektIznosHep')?.invalid &&
      prijavnicaForm.get('projektIznosHep')?.touched
        ? 'Polje je obvezno'
        : 'Unesite iznos u formatu 0.000,00'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('projektIznosHep')?.invalid &&
        prijavnicaForm.get('projektIznosHep')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('projektIznosHep')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('projektIznosHep')?.invalid &&
        prijavnicaForm.get('projektIznosHep')?.touched
    }" formControlName="projektIznosHep" />


                  <!-- poruke greške  -->
                  <!-- <div style="margin-left: 10px;" *ngIf="prijavnicaForm.get('projektIznosHep')?.errors?.['min']?.['required'] && prijavnicaForm.get('projektIznosHep')?.touched " class="error-message">
                                Iznos ne smije biti manji od {{ formatNumber(natjecaj!.minIznos)}} .
                            </div> -->

                  <div style="margin-left: 10px;"
                    *ngIf="prijavnicaForm.get('projektIznosHep')?.errors?.['min'] && prijavnicaForm.get('projektIznosHep')?.touched"
                    class="error-message">
                    Iznos ne smije biti manji od {{ formatNumber(postsService.natjecaj.minIznos)}} .
                  </div>
                  <div style="margin-left: 10px;"
                    *ngIf="prijavnicaForm.get('projektIznosHep')?.errors?.['max'] && prijavnicaForm.get('projektIznosHep')?.touched "
                    class="error-message">
                    Iznos ne smije biti veći od {{ formatNumber(postsService.natjecaj.maxIznos) }} .
                  </div>

                  <div style="margin-left: 10px;"
                    *ngIf="prijavnicaForm.get('projektIznosHep')?.errors?.['invalidFormat'] && prijavnicaForm.get('projektIznosHep')?.touched "
                    class="error-message">
                    Traženi format je 0.000,00
                  </div>

                </div>
              </div>


              <!-- ČETVRTI red -->
              <div class="row">

                <!-- ČETVRTI red, prva kolona -->
                <div class="col-md-6 col-sm-12">

                  <label for="projektIznos">Ukupan iznos potreban za provedbu projekta/programa rada*<br>
                    <span style="font-weight: lighter;font-size: smaller; "> (iznos u &#8364;)</span></label>
                  <input id="projektIznos" type="text" style="text-align: right;"
                    class="form-control italic-placeholder w-100" maxlength="15" inputmode="decimal"
                    (keydown)="blockInvalidCharactersSlova($event)"
                    (input)="onInputChangeFields(prijavnicaForm.get('projektIznos')?.value, 'projektIznos')"
                    [placeholder]="
      prijavnicaForm.get('projektIznos')?.invalid &&
      prijavnicaForm.get('projektIznos')?.touched
        ? 'Polje je obvezno'
        : 'Unesite iznos u formatu 0.000.000.000,00'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('projektIznos')?.invalid &&
        prijavnicaForm.get('projektIznos')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('projektIznos')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('projektIznos')?.invalid &&
        prijavnicaForm.get('projektIznos')?.touched
    }" formControlName="projektIznos" />

                  <div class="error-message" *ngIf="
      prijavnicaForm.hasError('ukupnoManjeOdHep') &&
      (prijavnicaForm.get('projektIznos')?.touched ||
        prijavnicaForm.get('projektIznosHep')?.touched)
    " style="margin-left: 10px;">
                    Ukupan iznos za provedbu projekta ne smije biti manji od iznosa koji se traži od HEP-a.
                  </div>
                </div>

                <!-- <div style="margin-left: 10px;"
            *ngIf="prijavnicaForm.get('projektIznos')?.invalid && prijavnicaForm.get('projektIznos')?.touched"
            class="error-message">
            Traženi format je 0.000.000.000,00
          </div>
          <div style="margin-left: 10px;" class="error-message"
          *ngIf="prijavnicaForm.get('projektIznos')?.invalid && prijavnicaForm.get('projektIznos')?.touched">
          Polje je obvezno.
        </div> -->
                <!-- ČETVRTI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <!-- odgovorna osoba -->
                  <label for="projektOdgOs">Osoba odgovorna za provedbu projekta/programa
                    rada*
                    <span style="font-weight: lighter; font-size: smaller;"> (ime i prezime, kvalifikacija,
                      iskustva - maksimalno 200 znakova s razmacima)</span></label>

                  <input id="projektOdgOs" type="text" class="form-control italic-placeholder w-100" maxlength="200"
                    (input)="updateProjektOdgOsCharacterCount()" [placeholder]="
      prijavnicaForm.get('projektOdgOs')?.invalid &&
      prijavnicaForm.get('projektOdgOs')?.touched
        ? 'Polje je obvezno'
        : 'Unesite naziv odgovorne osobe'
    " [ngClass]="{
      'invalid-input':
        prijavnicaForm.get('projektOdgOs')?.invalid &&
        prijavnicaForm.get('projektOdgOs')?.touched,
      'valid-placeholder':
        prijavnicaForm.get('projektOdgOs')?.valid,
      'invalid-placeholder':
        prijavnicaForm.get('projektOdgOs')?.invalid &&
        prijavnicaForm.get('projektOdgOs')?.touched
    }" formControlName="projektOdgOs" />

                  <div class="character-count">
                    <span>{{ projektOdgOsCurrentCharacterCount }} / 200 znakova</span>
                  </div>
                </div>

              </div>


              <!--PETI red -->
              <div class="row">

                <!-- PETI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <div class="col">
                    <span class="responsive-col"></span>
                  </div>
                  <label for="projektProblem">Na koji način ste ustvrdili postojanje
                    problema*</label>
 <div class="textarea-container">
                  <textarea id="projektProblem" class="italic-placeholder" type="text"
                    [placeholder]="prijavnicaForm.get('projektProblem')?.invalid && prijavnicaForm.get('projektProblem')?.touched ? 'Polje je obvezno' : 'Opišite situacije u kojima ste uočili problem koji želite riješiti'"
                    [ngClass]="{'invalid-textarea': prijavnicaForm.get('projektProblem')?.invalid && prijavnicaForm.get('projektProblem')?.touched,
                      'valid-placeholder': prijavnicaForm.get('projektProblem')?.valid,
                      'invalid-placeholder': prijavnicaForm.get('projektProblem')?.invalid && prijavnicaForm.get('projektProblem')?.touched
                  }" class="form-control" maxlength="2000" (input)="updateProjektProblemCharacterCount()"
                    formControlName="projektProblem"></textarea>

                  <div class="character-count">
                    <span>{{ projektProblemCurrentCharacterCount }} / 2000 znakova</span>
                  </div>
                  </div>
                  <!-- <div style="margin-left: 10px;" class="error-message"
                *ngIf="prijavnicaForm.get('projektProblem')?.invalid && prijavnicaForm.get('projektProblem')?.touched">
                Polje je obvezno.
              </div> -->

                </div>

                <!-- PETI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="projektCilj">Navedite ciljeve koji se postižu provođenjem
                    predloženog projekta/programa rada*<span style="font-weight: lighter;font-size: smaller;">
                      (maksimalno
                      2000 znakova s
                      razmacima)</span></label>
            <div class="textarea-container">
                  <textarea id="projektCilj" class="italic-placeholder" formControlName="projektCilj"
                    [placeholder]="prijavnicaForm.get('projektCilj')?.invalid && prijavnicaForm.get('projektCilj')?.touched ? 'Polje je obvezno' : 'Unesite ciljeve koji se postižu provođenjem projekta'"
                    [ngClass]="{'invalid-textarea': prijavnicaForm.get('projektCilj')?.invalid && prijavnicaForm.get('projektCilj')?.touched,
                      'valid-placeholder': prijavnicaForm.get('projektCilj')?.valid,
                      'invalid-placeholder': prijavnicaForm.get('projektCilj')?.invalid && prijavnicaForm.get('projektCilj')?.touched
                  }" class="form-control" maxlength="2000" (input)="updateProjektCiljCharacterCount()">
                </textarea>
                  <div class="character-count">
                    <span>{{ projektCiljCurrentCharacterCount }} / 2000 znakova</span>
                  </div>
</div>



                  <!-- <div style="margin-left: 10px;" class="error-message"
                *ngIf="prijavnicaForm.get('projektCilj')?.invalid && prijavnicaForm.get('projektCilj')?.touched">
                Polje je obvezno.
              </div> -->
                </div>
              </div>

              <!-- LABEL  -->
              <div class="row">
                <!-- LABEL prva kolona -->
                <div class="col">
                  <span class="responsive-col"></span>
                </div>

              </div>
              <!-- ŠESTI red -->
              <div class="row">
                <!-- ŠESTI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="projektRezultati">Opišite rezultate koje očekujete po
                    završetku projekta/programa rada*<span style="font-weight: lighter;font-size: smaller;"> (maksimalno
                      2000
                      znakova s razmacima)</span></label>
                      <div class="textarea-container">
                  <textarea id="projektRezultati" class="italic-placeholder" formControlName="projektRezultati"
                    type="text"
                    [placeholder]="prijavnicaForm.get('projektRezultati')?.invalid && prijavnicaForm.get('projektRezultati')?.touched ? 'Polje je obvezno' : 'Opišite kako bi uspješan projekt trebao izgledati'"
                    [ngClass]="{'invalid-textarea': prijavnicaForm.get('projektRezultati')?.invalid && prijavnicaForm.get('projektRezultati')?.touched,
                      'valid-placeholder': prijavnicaForm.get('projektRezultati')?.valid,
                      'invalid-placeholder': prijavnicaForm.get('projektRezultati')?.invalid && prijavnicaForm.get('projektRezultati')?.touched
                  }" class="form-control" maxlength="2000" (input)="updateProjektRezultatiCharacterCount()">
          </textarea>
                  <div class="character-count">
                    <span>{{ projektRezultatiCurrentCharacterCount }} / 2000 znakova</span>
                  </div>
</div>
                  <!-- <div style="margin-left: 10px;" class="error-message"
                *ngIf="prijavnicaForm.get('projektRezultati')?.invalid && prijavnicaForm.get('projektRezultati')?.touched">
                Polje je obvezno.
              </div> -->
                </div>

                <!-- ŠESTI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="projektAktivnosti">Aktivnosti provedbe projekta/programa
                    rada - popis aktivnosti, nositelji, trajanje*<span style="font-weight: lighter;font-size: smaller;">
                      (maksimalno 2000 znakova
                      s razmacima)</span></label>
                      <div class="textarea-container">
                  <textarea id="projektAktivnosti" class="italic-placeholder" formControlName="projektAktivnosti"
                    [placeholder]="prijavnicaForm.get('projektAktivnosti')?.invalid && prijavnicaForm.get('projektAktivnosti')?.touched ? 'Polje je obvezno' : 'Unesite aktivnosti projekta'"
                    [ngClass]="{'invalid-textarea': prijavnicaForm.get('projektAktivnosti')?.invalid && prijavnicaForm.get('projektAktivnosti')?.touched,
                      'valid-placeholder': prijavnicaForm.get('projektAktivnosti')?.valid,
                      'invalid-placeholder': prijavnicaForm.get('projektAktivnosti')?.invalid && prijavnicaForm.get('projektAktivnosti')?.touched
                  }" class="form-control" maxlength="2000" (input)="updateProjektAktivnostiCharacterCount()">
              </textarea>

                  <div class="character-count">
                    <span>{{ projektAktivnostiCurrentCharacterCount }} / 2000 znakova</span>
                  </div>
                  </div>
                  <!-- <div style="margin-left: 10px;" class="error-message"
                *ngIf="prijavnicaForm.get('projektAktivnosti')?.invalid && prijavnicaForm.get('projektAktivnosti')?.touched">
                Polje je obvezno.
              </div> -->
                </div>
              </div>
              <!-- RAZMAK red  1 br-->
              <div class="row">

                <!-- IZMEĐU red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <div class="col">
                    <span class="responsive-col"></span>
                  </div>
                </div>
              </div>
              <!-- SEDMI red -->
              <div class="row">
                <!-- SEDMI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="projektKorisnici">Korisnici projekta/programa rada-broj i
                    struktura*<span style="font-weight: lighter;font-size: smaller;"> (maksimalno 2000
                      znakova s razmacima)</span></label>
                       <div class="textarea-container">
                  <textarea id="projektKorisnici" class="italic-placeholder"
                    [placeholder]="prijavnicaForm.get('projektKorisnici')?.invalid && prijavnicaForm.get('projektKorisnici')?.touched ? 'Polje je obvezno' : 'Unesite informacije o korisnicima projekta'"
                    [ngClass]="{'invalid-textarea': prijavnicaForm.get('projektKorisnici')?.invalid && prijavnicaForm.get('projektKorisnici')?.touched,
                      'valid-placeholder': prijavnicaForm.get('projektKorisnici')?.valid,
                      'invalid-placeholder': prijavnicaForm.get('projektKorisnici')?.invalid && prijavnicaForm.get('projektKorisnici')?.touched
                  }" class="form-control" formControlName="projektKorisnici" maxlength="2000"
                    (input)="updateProjektKorisniciCharacterCount()"></textarea>

                  <div class="character-count">
                    <span>{{ projektKorisniciCurrentCharacterCount }} / 2000 znakova</span>
                  </div>
                  </div>
                  <!-- <div style="margin-left: 10px;" class="error-message"
                *ngIf="prijavnicaForm.get('projektKorisnici')?.invalid && prijavnicaForm.get('projektKorisnici')?.touched">
                Polje je obvezno.
              </div> -->
                </div>
                <!-- SEDMI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="projektPracenje">Praćenje provedbe i vrednovanje uspješnosti
                    provedbe*<span style="font-weight:lighter; font-size:smaller">(maksimalno 2000 znakova s
                      razmacima)</span></label>
                        <div class="textarea-container">
                  <textarea id="projektPracenje" class="italic-placeholder"
                    [placeholder]="prijavnicaForm.get('projektPracenje')?.invalid && prijavnicaForm.get('projektPracenje')?.touched ? 'Polje je obvezno' : 'Unesite na koji način pratite projekt i kako vrednujete uspješnost provedbe projekta'"
                    [ngClass]="{'invalid-textarea': prijavnicaForm.get('projektPracenje')?.invalid && prijavnicaForm.get('projektPracenje')?.touched,
              'valid-placeholder': prijavnicaForm.get('projektPracenje')?.valid,
              'invalid-placeholder': prijavnicaForm.get('projektPracenje')?.invalid && prijavnicaForm.get('projektPracenje')?.touched
          }" class="form-control" formControlName="projektPracenje" maxlength="2000"
                    (input)="updateProjektPracenjeCharacterCount()">
              </textarea>
                  <div class="character-count">
                    <span>{{ projektPracenjeCurrentCharacterCount }} / 2000 znakova</span>
                  </div>
                  </div>
                  <!-- <div style="margin-left: 10px;" class="error-message"
                *ngIf="prijavnicaForm.get('projektPracenje')?.invalid && prijavnicaForm.get('projektPracenje')?.touched">
                Polje je obvezno.
              </div> -->
                </div>
              </div>
              <div class="row">
                <div class="my-div">
                  <span></span>
                </div>
              </div>
              <div>
                <button type="button" (click)="previousStep()" style="margin-right: 8px;">Nazad</button>
                <button type="button" (click)="nextStep()" style="float: right;">Dalje</button>
              </div>
            </div>
          </div>
          <!-- ČETVRTA STRANICA -->
          <div class="grid-form" style="width: 100%;height:auto  ">
            <div *ngIf="currentStep === 4" @flyInOut>
              <h2 style="   font-size: 1.7em !important; color: #4c7bc1  ; ">Kontakt podaci</h2>
              <!-- <span style="font-weight: lighter;font-size: smaller;color: rgb(15, 78, 130)"> Poželjno je upisati podatke različite od podataka koji se odnose na ovlaštenu osobu</span> -->
              <!-- ČETVRTA STRANICA -->
              <!-- PRVI red -->
              <!-- RAZMAK red  1 br-->

              <div class="row">
                <div class="col">
                  <span class="responsive-col"></span>
                </div>
              </div>
              <!-- TREĆI red -->
              <div class="row">
                <!-- TREĆI red, prva kolona -->
                <div class="col-md-6 col-sm-12" style="align-items:center">
                  <label for="predlagodgKontaktOs" class="d-flex align-items-center gap-1">
                    Kontakt osoba prijavitelja*
                    <span class="question-mark" (click)="showInfo = !showInfo" title="Klikni za više informacija">
                      ?
                    </span>

                    <div *ngIf="showInfo" class="tooltip-box">
                      Poželjno je upisati podatke različite od podataka koji se odnose na ovlaštenu osobu.
                    </div>
                    <!-- <app-info-button
      infoText="Poželjno je upisati podatke različite od podataka koji se odnose na ovlaštenu osobu.">
    </app-info-button> -->
                    <span style="font-weight: lighter; font-size: smaller;">(ime i prezime)</span>
                  </label>

                  <input id="predlagodgKontaktOs" type="text" (keydown)="blockInvalidCharactersBrojevi($event)"
                    [placeholder]="prijavnicaForm.get('predlagodgKontaktOs')?.invalid && prijavnicaForm.get('predlagodgKontaktOs')?.touched
                        ? 'Polje je obvezno'
                        : 'Unesite kontakt osobu prijavitelja'" class="form-control italic-placeholder" [ngClass]="{
           'invalid-input': prijavnicaForm.get('predlagodgKontaktOs')?.invalid && prijavnicaForm.get('predlagodgKontaktOs')?.touched,
           'valid-placeholder': prijavnicaForm.get('predlagodgKontaktOs')?.valid,
           'invalid-placeholder': prijavnicaForm.get('predlagodgKontaktOs')?.invalid && prijavnicaForm.get('predlagodgKontaktOs')?.touched
         }" formControlName="predlagodgKontaktOs" />
                </div>



                <!-- TREĆI red, druga kolona -->
                <div class="col" style="align-items:center; margin-top:2px;">
                  <label for="predlagodgTel">Tel/mob. kontakt osobe*</label>
                  <input id="predlagodgTel" type="tel" inputmode="numeric" class="form-control italic-placeholder w-100"
                    [placeholder]="prijavnicaForm.get('predlagodgTel')?.invalid && prijavnicaForm.get('predlagodgTel')?.touched
    ? 'Polje je obvezno'
    : 'Unesite broj telefona kontakt osobe'" [ngClass]="{
    'invalid-input': prijavnicaForm.get('predlagodgTel')?.invalid && prijavnicaForm.get('predlagodgTel')?.touched,
    'valid-placeholder': prijavnicaForm.get('predlagodgTel')?.valid,
    'invalid-placeholder': prijavnicaForm.get('predlagodgTel')?.invalid && prijavnicaForm.get('predlagodgTel')?.touched
  }" pattern="[0-9]*" maxlength="10" (keydown)="blockInvalidCharacters($event)" formControlName="predlagodgTel" />
                  <!-- <label for="predlagodgTel">Tel/mob. kontakt osobe*</label>
                                        <input id="predlagodgTel" [placeholder]="prijavnicaForm.get('predlagodgTel')?.invalid && prijavnicaForm.get('predlagodgTel')?.touched ? 'Polje je obvezno' : 'Unesite broj telefona kontakt osobe'" class="italic-placeholder" [ngClass]="{'invalid-input': prijavnicaForm.get('predlagodgTel')?.invalid && prijavnicaForm.get('predlagodgTel')?.touched,
                        'valid-placeholder': prijavnicaForm.get('predlagodgTel')?.valid,
                        'invalid-placeholder': prijavnicaForm.get('predlagodgTel')?.invalid && prijavnicaForm.get('predlagodgTel')?.touched
                  }" pattern="[0-9]*" maxlength="10" (keydown)="blockInvalidCharacters($event)" formControlName="predlagodgTel" /> -->
                  <!-- <div style="margin-left: 10px;" class="error-message"
                  *ngIf="prijavnicaForm.get('predlagodgTel')?.invalid && prijavnicaForm.get('predlagodgTel')?.touched">
                  Polje je obvezno.
                </div> -->
                </div>
              </div>
              <!-- RAZMAK red  1 br-->
              <div class="row">
                <div class="col">
                  <span class="responsive-col"></span>
                </div>
              </div>
              <!-- ČETVRTI RED-->
              <div class="row">
                <!--ČETVRTI red, prva kolona -->
                <div class="col-md-6 col-sm-12">
                  <label for="predlagodgEmail">E-mail kontakt osobe*</label>
                  <input id="predlagodgEmail" type="email" class="form-control italic-placeholder w-100" [placeholder]="prijavnicaForm.get('predlagodgEmail')?.invalid && prijavnicaForm.get('predlagodgEmail')?.touched
      ? 'Polje je obvezno'
      : 'Unesite e-mail kontakt osobe'" [ngClass]="{
      'invalid-input': prijavnicaForm.get('predlagodgEmail')?.invalid && prijavnicaForm.get('predlagodgEmail')?.touched,
      'valid-placeholder': prijavnicaForm.get('predlagodgEmail')?.valid,
      'invalid-placeholder': prijavnicaForm.get('predlagodgEmail')?.invalid && prijavnicaForm.get('predlagodgEmail')?.touched
    }" formControlName="predlagodgEmail" />
                  <div
                    *ngIf="prijavnicaForm.get('predlagodgEmail')?.invalid && prijavnicaForm.get('predlagodgEmail')?.touched"
                    class="error-message">
                    E-mail mora biti ispravnog formata
                  </div>
                </div>
                <!-- ČETVRTI red, druga kolona -->
                <div class="col-md-6 col-sm-12">
                </div>
              </div>

              <!-- RAZMAK red 5 br -->
              <div class="row">
                <div class="my-div">
                  <span></span>
                </div>
              </div>
              <!-- ZADNJI red  -->
              <div>
                <button type="button" (click)="previousStep()" style="margin-right: 8px;">Nazad</button>
                <button type="button" (click)="nextStep()" style="float: right;">Dalje</button>
              </div>
              <!-- [disabled]="prijavnicaForm.invalid" -->
            </div>
          </div>
          <!-- PETA STRANICA   -->




          <!-- PETA STRANICA NOVO  -->

          <div class="grid-form" style="width: 100%; height:auto;">
            <div *ngIf="currentStep === 5" @flyInOut>
              <div class="my-newspace">
                <h2 style="   font-size: 1.7em !important; color: #4c7bc1  ; ">Prilozi</h2>

                <!-- PRVI red  obrazacProracuna POČINJE-->

                <!-- PRVI red labela  PRVI red obrazacProracuna-->
                <div class="row" style="align-items:center">
                  <div style="align-items:center">
                    <label for="obrazacProracuna" style=" margin-top: 40px;">Obrazac proračuna
                      programa/projekta*
                      <span style="font-weight: lighter;font-size: smaller;"> (Prihvaćamo isključivo formate: pdf, docx,
                        jpg, png, zip)</span>
                      <!-- <app-info-button
      infoText="Prihvaćamo isključivo formate: pdf, docx, jpg, png">
    </app-info-button> -->

                    </label>
                  </div>
                </div>
                <!-- PRVI red obrazacProracuna-->
                <div class="row" style=" margin-left: 5px;  display: flex;  align-items: center; ">
                  <div [formGroup]="prijavnicaFormFile" [ngClass]="{'invalid-inputf': klik1===true }"
                    style="position:relative;  background-color: white; border: 1px solid #ccc; border-radius: 3px !important;
                transition: border-color 0.3s ease !important; height: 40px;max-width: 700px;  width: 100%; display: flex; align-items: center; overflow: hidden">
                    <!-- border: 1px solid #ccc; -->
                    <!-- Prikaz datoteke -->
                    <!-- <p>{{ klikO }}</p> -->
                    <input id="hiddenFileInput1" class="inputp" *ngIf="selectedFile1" type="text"
                      [value]="selectedFile1.name" maxlength="80" />
                    <!-- [ngClass]="{'invalid-inputf': prijavnicaFormFile.get('obrazacProracuna')?.invalid && prijavnicaFormFile.get('obrazacProracuna')?.touched}" -->
                    <!-- Gumb za uklanjanje datoteke -->
                    <span *ngIf="selectedFile1" (click)="removeFile('obrazacProracuna')"
                      style="color: red; cursor: pointer; font-weight: bold; position: absolute; right: 15px; ">&times;</span>
                    <!-- Skriveni input da se sakrije defaultni izgled input file=type-->
                    <input #fileInput1 id="hiddenFileInput1F" type="file"
                      (change)="onFileSelected($event, 'obrazacProracuna')" accept=".pdf,.doc,.docx,.jpg,.png,.zip"
                      style="display: none;" />
                    <div *ngIf="this.klik1===true" class="error-messagef">
                      Polje je obvezno.
                    </div>
                  </div>

                  <button mat-raised-button type="button" (click)="triggerFileInput1()" class="small-button"
                    style="height: 40px; width: auto;margin-top: 1px;" (mouseover)="hover1 = true"
                    (mouseleave)="hover1 = false" [style.backgroundColor]="hover1 ? '#007bff' : '#f7fafc'  "
                    [style.color]="hover1 ? '#ffffff'  : '#000000'  ">Dodaj prilog</button>
                </div>
                <div class="error-messagef" *ngFor="let msg of validationMessages1" [style.color]="'red'">{{ msg }}
                </div>
                <!-- PRVI red  obrazacProracuna ZAVRŠAVA-->



                <!-- DRUGI red dokazRegistarNadl POČINJE-->
                <!-- DRUGI red labela dokazRegistarNadl -->
                <div class="row">
                  <div>
                    <label for="dokazRegistarNadl" style=" margin-top: 40px;">Dokaz o registraciji - izvadak iz
                      nadležnog
                      registra*
                      <span style="font-weight: lighter;font-size: smaller;"> (Prihvaćamo isključivo formate: pdf, docx,
                        jpg, png, zip)</span>
                      <!-- <app-info-button
      infoText="Prihvaćamo isključivo formate: pdf, docx, jpg, png">
    </app-info-button> -->


                    </label>
                  </div>
                </div>
                <!-- DRUGI RED dokazRegistarNadl-->
                <div class="row" style=" margin-left: 5px;  display: flex;  align-items: center; ">
                  <div [formGroup]="prijavnicaFormFile" [ngClass]="{'invalid-inputf': klik2===true }"
                    style="position:relative;  background-color: white; border: 1px solid #ccc; border-radius: 3px !important;
              transition: border-color 0.3s ease !important; height: 40px;max-width: 700px;  width: 100%; display: flex; align-items: center; overflow: hidden">

                    <!-- Prikaz datoteke -->

                    <input id="hiddenFileInput2" class="inputp" *ngIf="selectedFile2" type="text"
                      [value]="selectedFile2.name" maxlength="80">
                    <!-- Gumb za uklanjanje datoteke -->
                    <span *ngIf="selectedFile2" (click)="removeFile('dokazRegistarNadl')"
                      style="color: red; cursor: pointer; font-weight: bold; position: absolute; right: 15px; ">&times;</span>


                    <!-- Skriveni input -->
                    <input #fileInput2 id="hiddenFileInput2F" type="file"
                      (change)="onFileSelected($event, 'dokazRegistarNadl')" accept=".pdf,.doc,.docx,.jpg,.png,.zip"
                      style="display: none;" />
                    <div *ngIf="
                                  this.klik2===true" class="error-messagef">
                      Polje je obvezno.
                    </div>
                  </div>
                  <button type="button" (click)="triggerFileInput2()" class="small-button"
                    style="height: 40px; width: auto;margin-top: 1px;" (mouseover)="hover2 = true"
                    (mouseleave)="hover2 = false" [style.backgroundColor]="hover2 ? '#007bff' : '#f7fafc'  "
                    [style.color]="hover2 ? '#ffffff'  : '#000000'  ">Dodaj prilog</button>
                </div>
                <div class="error-messagef" *ngFor="let msg of validationMessages2" [style.color]="'red'">{{ msg }}
                </div>
                <!-- DRUGI red dokazRegistarNadl ZAVRŠAVA-->





                <!-- ŠESTI  red dokazRegistarNeprofit POČINJE ustvari bio je šesti al neda je rekla da ostane treći jer je kao grupirano po temema-->
                <!-- ŠESTI red labela -->
                <div class="row">
                  <div>

                    <label for="dokazRegistarNeprofit" style=" margin-top: 40px;">Dokaz o upisu u registar neprofitnih
                      organizacija
                      <span class="info-wrap">
                        <span class="question-mark" (click)="showInfo = !showInfo">?</span>
                        <div *ngIf="showInfo" class="tooltip-box">
                          Samo za obveznike upisa u RNO
                        </div>
                      </span>
                      <!-- <span
  class="question-mark"
  (click)="showInfo = !showInfo"
  title="Klikni za više informacija">
  ?
</span> -->


                      <!-- neprofitnih organizacija  <app-info-button
      infoText="samo za obveznike upisa">
    </app-info-button> -->
                      <span style="font-weight: lighter;font-size: smaller;"> (Prihvaćamo isključivo formate: pdf, docx,
                        jpg, png, zip)</span>


                    </label>

                  </div>
                </div>
                <!-- ŠESTI red -->
                <div class="row" style=" margin-left: 5px;  display: flex;  align-items: center; ">
                  <div [formGroup]="prijavnicaFormFile"
                    style="position:relative;  background-color: white; border: 1px solid #ccc; border-radius: 3px !important;
              transition: border-color 0.3s ease !important; height: 40px;max-width: 700px;  width: 100%; display: flex; align-items: center; overflow: hidden">

                    <!-- Prikaz datoteke -->

                    <input id="hiddenFileInput6" class="inputp" *ngIf="selectedFile6" type="text"
                      [value]="selectedFile6.name" maxlength="80">


                    <!-- Gumb za uklanjanje datoteke -->
                    <span *ngIf="selectedFile6" (click)="removeFile('dokazRegistarNeprofit')"
                      style="color: red; cursor: pointer; font-weight: bold;position: absolute; right: 15px; ">&times;</span>
                    <!-- </div> -->

                    <!-- Skriveni input -->
                    <input #fileInput6 id="hiddenFileInput6F" type="file"
                      (change)="onFileSelected($event, 'dokazRegistarNeprofit')" accept=".pdf,.doc,.docx,.jpg,.png,.zip"
                      style="display: none;" />

                  </div>
                  <button type="button" (click)="triggerFileInput6()" class="small-button"
                    style="height: 40px; width: auto;margin-top: 1px;" (mouseover)="hover6 = true"
                    (mouseleave)="hover6 = false" [style.backgroundColor]="hover6 ? '#007bff' : '#f7fafc'  "
                    [style.color]="hover6 ? '#ffffff'  : '#000000'  ">Dodaj prilog</button>
                </div>
                <div class="error-messagef" *ngFor="let msg of validationMessages6" [style.color]="'red'">{{ msg }}
                </div>


                <!-- ŠESTI  red dokazRegistarNeprofit ZAVRŠAVA  ustvari bio je šesti al neda je rekla da ostane treći jer je kao grupirano po temema-->







                <!-- nova polja počinju -->
                <!-- TREĆI red  potvrdaPorezna POČINJE-->

                <!-- TREĆI red labela potvrdaPorezna -->
                <div class="row">
                  <div>
                    <label for="potvrdaPorezna" style=" margin-top: 40px;">Potvrda Porezne uprave o plaćenim
                      doprinosima i porezima
                      *
                      <span style="font-weight: lighter;font-size: smaller;"> (Prihvaćamo isključivo formate: pdf, docx,
                        jpg, png, zip)</span>
                      <!-- <app-info-button
      infoText="Prihvaćamo isključivo formate: pdf, docx, jpg, png">
    </app-info-button> -->


                    </label>
                  </div>
                </div>
                <!-- TREĆI RED potvrdaPorezna-->
                <div class="row" style=" margin-left: 5px;  display: flex;  align-items: center; ">
                  <div [formGroup]="prijavnicaFormFile" [ngClass]="{'invalid-inputf': klik3===true }"
                    style="position:relative;  background-color: white; border: 1px solid #ccc; border-radius: 3px !important;
              transition: border-color 0.3s ease !important; height: 40px;max-width: 700px;  width: 100%; display: flex; align-items: center; overflow: hidden">

                    <!-- Prikaz datoteke -->

                    <input id="hiddenFileInput3" class="inputp" *ngIf="selectedFile3" type="text"
                      [value]="selectedFile3.name" maxlength="80">
                    <!-- Gumb za uklanjanje datoteke -->
                    <span *ngIf="selectedFile3" (click)="removeFile('potvrdaPorezna')"
                      style="color: red; cursor: pointer; font-weight: bold; position: absolute; right: 15px; ">&times;</span>


                    <!-- Skriveni input -->
                    <input #fileInput3 id="hiddenFileInput3F" type="file"
                      (change)="onFileSelected($event, 'potvrdaPorezna')" accept=".pdf,.doc,.docx,.jpg,.png,.zip"
                      style="display: none;" />
                    <div *ngIf="
                                  this.klik2===true" class="error-messagef">
                      Polje je obvezno.
                    </div>
                  </div>
                  <button type="button" (click)="triggerFileInput3()" class="small-button"
                    style="height: 40px; width: auto;margin-top: 1px;" (mouseover)="hover3 = true"
                    (mouseleave)="hover3 = false" [style.backgroundColor]="hover3 ? '#007bff' : '#f7fafc'  "
                    [style.color]="hover3 ? '#ffffff'  : '#000000'  ">Dodaj prilog</button>
                </div>
                <div class="error-messagef" *ngFor="let msg of validationMessages3" [style.color]="'red'">{{ msg }}
                </div>

                <!-- TREĆI red  potvrdaPorezna ZAVRŠAVA-->

                <!-- ČETVRTI red uvjerenjeNekaz POČINJE-->
                <!-- ČETVRTI red labela uvjerenjeNekaz -->
                <div class="row">
                  <div>
                    <label for="uvjerenjeNekaz" style=" margin-top: 40px;">Uvjerenje da se ne vodi kazneni postupak*
                      <span style="font-weight: lighter;font-size: smaller;"> (Prihvaćamo isključivo formate: pdf, docx,
                        jpg, png, zip)</span>
                      <!-- <app-info-button
      infoText="Prihvaćamo isključivo formate: pdf, docx, jpg, png">
    </app-info-button> -->


                    </label>
                  </div>
                </div>
                <!-- ČETVRTI RED uvjerenjeNekaz-->
                <div class="row" style=" margin-left: 5px;  display: flex;  align-items: center; ">
                  <div [formGroup]="prijavnicaFormFile" [ngClass]="{'invalid-inputf': klik4===true }"
                    style="position:relative;  background-color: white; border: 1px solid #ccc; border-radius: 3px !important;
              transition: border-color 0.3s ease !important; height: 40px;max-width: 700px;  width: 100%; display: flex; align-items: center; overflow: hidden">

                    <!-- Prikaz datoteke -->

                    <input id="hiddenFileInput4" class="inputp" *ngIf="selectedFile4" type="text"
                      [value]="selectedFile4.name" maxlength="80">
                    <!-- Gumb za uklanjanje datoteke -->
                    <span *ngIf="selectedFile4" (click)="removeFile('uvjerenjeNekaz')"
                      style="color: red; cursor: pointer; font-weight: bold; position: absolute; right: 15px; ">&times;</span>


                    <!-- Skriveni input -->
                    <input #fileInput4 id="hiddenFileInput4F" type="file"
                      (change)="onFileSelected($event, 'uvjerenjeNekaz')" accept=".pdf,.doc,.docx,.jpg,.png,.zip"
                      style="display: none;" />
                    <div *ngIf="
                                  this.klik4===true" class="error-messagef">
                      Polje je obvezno.
                    </div>
                  </div>
                  <button type="button" (click)="triggerFileInput4()" class="small-button"
                    style="height: 40px; width: auto;margin-top: 1px;" (mouseover)="hover4 = true"
                    (mouseleave)="hover4 = false" [style.backgroundColor]="hover4 ? '#007bff' : '#f7fafc'  "
                    [style.color]="hover4 ? '#ffffff'  : '#000000'  ">Dodaj prilog</button>
                </div>
                <div class="error-messagef" *ngFor="let msg of validationMessages4" [style.color]="'red'">{{ msg }}
                </div>


                <!-- PETI red izjavaOsnova POČINJE-->
                <!-- PETI red labela izjavaOsnova -->
                <div class="row">
                  <div>
                    <label for="izjavaOsnova" style=" margin-top: 40px;">Izjava o nepostojanju osnove za zabranu dodjele
                      donacije*
                      <span style="font-weight: lighter;font-size: smaller;"> (Prihvaćamo isključivo formate: pdf, docx,
                        jpg, png, zip)</span>
                      <!-- <app-info-button
      infoText="Prihvaćamo isključivo formate: pdf, docx, jpg, png">
    </app-info-button> -->


                    </label>
                  </div>
                </div>
                <!-- PETI RED izjavaOsnova-->
                <div class="row" style=" margin-left: 5px;  display: flex;  align-items: center; ">
                  <div [formGroup]="prijavnicaFormFile" [ngClass]="{'invalid-inputf': klik5===true }"
                    style="position:relative;  background-color: white; border: 1px solid #ccc; border-radius: 3px !important;
              transition: border-color 0.3s ease !important; height: 40px;max-width: 700px;  width: 100%; display: flex; align-items: center; overflow: hidden">

                    <!-- Prikaz datoteke -->

                    <input id="hiddenFileInput5" class="inputp" *ngIf="selectedFile5" type="text"
                      [value]="selectedFile5.name" maxlength="80">
                    <!-- Gumb za uklanjanje datoteke -->
                    <span *ngIf="selectedFile5" (click)="removeFile('izjavaOsnova')"
                      style="color: red; cursor: pointer; font-weight: bold; position: absolute; right: 15px; ">&times;</span>


                    <!-- Skriveni input -->
                    <input #fileInput5 id="hiddenFileInput5F" type="file"
                      (change)="onFileSelected($event, 'izjavaOsnova')" accept=".pdf,.doc,.docx,.jpg,.png,.zip"
                      style="display: none;" />
                    <div *ngIf="
                                  this.klik5===true" class="error-messagef">
                      Polje je obvezno.
                    </div>
                  </div>
                  <button type="button" (click)="triggerFileInput5()" class="small-button"
                    style="height: 40px; width: auto;margin-top: 1px;" (mouseover)="hover5 = true"
                    (mouseleave)="hover5 = false" [style.backgroundColor]="hover5 ? '#007bff' : '#f7fafc'  "
                    [style.color]="hover5 ? '#ffffff'  : '#000000'  ">Dodaj prilog</button>
                </div>
                <div class="error-messagef" *ngFor="let msg of validationMessages5" [style.color]="'red'">{{ msg }}
                </div>

                <!-- PETI red izjavaOsnova ZAVRŠAVA-->


                <!-- nova polja završavaju -->




                <!-- SEDMI  red dokumentiOstalo POČINJE-->
                <!-- SEDMI red labela -->
                <div class="row">

                  <!-- <label for="dokumentiOstalo" style="display: flex; margin-top: 40px;">

                 <span style="font-weight: lighter;font-size: smaller;">             (Prihvaćamo isključivo formate: pdf, docx, jpg, png)</span> -->

                  <label for="dokumentiOstalo" style=" margin-top: 40px;">Ostali
                    dokumenti
                    <span style="font-weight: lighter;font-size: smaller;"> (Prihvaćamo isključivo formate: pdf, docx,
                      jpg, png, zip)</span>



                    <!-- <app-info-button
      infoText="Prihvaćamo isključivo formate: pdf, docx, jpg, png">
    </app-info-button> -->

                  </label>
                  <!-- <div class="row" style=" margin-left: 5px;  display: flex;  align-items: center; "> -->

                </div>
                <!-- SEDMI red -->
                <div class="row" style=" margin-left: 5px;  display: flex;  align-items: center; ">
                  <div [formGroup]="prijavnicaFormFile"
                    style="position:relative;  background-color: white; border: 1px solid #ccc; border-radius: 3px !important;
              transition: border-color 0.3s ease !important; height: 40px;max-width: 700px;  width: 100%; display: flex; align-items: center; overflow: hidden">

                    <!-- Okvir za gumb i prikaz datoteke -->

                    <!-- Gumb za dodavanje priloga -->
                    <input id="hiddenFileInput7" class="inputp" *ngIf="selectedFile7" type="text"
                      [value]="selectedFile7.name" maxlength="80">
                    <!-- Gumb za uklanjanje datoteke -->
                    <span *ngIf="selectedFile7" (click)="removeFile('dokumentiOstalo')"
                      style="color: red; cursor: pointer; font-weight: bold; position: absolute; right: 15px;">&times;</span>


                    <!-- Skriveni input -->
                    <input #fileInput7 id="hiddenFileInput7F" type="file"
                      (change)="onFileSelected($event, 'dokumentiOstalo')" accept=".pdf,.doc,.docx,.jpg,.png, .zip"
                      style="display: none;" />
                  </div>
                  <button type="button" (click)="triggerFileInput7()" class="small-button"
                    style="height: 40px; width: auto;margin-top: 1px;" (mouseover)="hover7 = true"
                    (mouseleave)="hover7 = false" [style.backgroundColor]="hover7 ? '#007bff' : '#f7fafc'  "
                    [style.color]="hover7 ? '#ffffff'  : '#000000'  ">Dodaj
                    prilog
                  </button>
                </div>
                <div class="error-messagef" *ngFor="let msg of validationMessages7" [style.color]="'red'">
                  {{ msg }}
                </div>
                <!-- SEDMI  red dokumentiOstalo ZAVRŠAVA-->
                <!-- RAZMAK red 5 br -->
                <div class="row">
                  <div class="my-div">
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="button-row">
                <button type="button" (click)="previousStep()">Nazad</button>
                <!-- type="submit" -->
                <button class="buttonmodal" type="submit" (click)="nextStep()">Pošalji</button>
              </div>
            </div>

          </div>




          <!-- -------------- -->
          <!-- </form> -->
          <div class="draggable-timer" (mousedown)="onMouseDown($event)" [style.left.px]="position.x"
            [style.top.px]="position.y">
            Preostalo vrijeme: {{ timeRemaining }}
          </div>
          <!-- Spinner koji se prikazuje dok se prijavnica šalje -->
          <div *ngIf="loading" class="spinner-overlay">
            <div class="spinner"></div>
            <p>Slanje u tijeku...</p>
          </div>
        </form>

        <!-- ZADNJA STRANICA - MODAL  -->
        <!-- ZADNJA STRANICA - MODAL  -->
        <!-- ZADNJA STRANICA - MODAL  -->
        <!-- ZADNJA STRANICA - MODAL  -->

        <div class="modal-overlay" *ngIf="showModal">

          <div class="modal-content">
            <h2 style="font-size: 23px; font-weight: bold;  color: rgb(15, 78, 130); ">PREGLED PRIJAVNICE</h2>

            <div class="col">
              <span class="responsive-col"></span>
            </div>



            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Područje prijave:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.nazivPodr || 'Nema podataka'" type="text" />
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>OIB:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagOib || 'Nema podataka'" type="text" />
              </div>
            </div>


            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Naziv:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagNaziv || 'Nema podataka'" type="text" />

              </div>
            </div>
            <!-- <div class="form-group"> -->
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Matični registar:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagMatReg || 'Nema podataka'" type="text" />
              </div>
            </div>
            <!-- <div class="form-group"> -->
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Ulica i broj:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagUlica || 'Nema podataka'" type="text" />
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Poštanski broj:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagPtBr || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Grad/mjesto:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input class="modalinput" readonly [value]="prijavnicaForm.value.predlagGrad || 'Nema podataka'"
                  type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Županija:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagZupanija || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>IBAN:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagIban || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Otvoren kod banke:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagBanka || 'Nema podataka'" type="text" />
              </div>
            </div>
            <!-- ubacujem PNB -->
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Model i poziv na broj:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="row">
                  <div class="col-auto">
                    <input readonly [value]="'HR' + (prijavnicaForm.value.predlagModel || 'Nema podataka')" type="text"
                      style="width: 100px;" />
                  </div>
                  <div class="col">
                    <input readonly [value]="prijavnicaForm.value.predlagPnb || 'Nema podataka'" type="text" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12 pregledprijave">
                <label>Osoba ovlaštena za zastupanje prijavitelja:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagOvlOs || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Funkcija ovlaštene osobe:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagFjaOvlOs || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Broj mobitela i/ili telefona:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagTel || 'Nema podataka'" type="number" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>E-mail:</label>
              </div>
              <div class="col-md-6 col-sm-12l">
                <input readonly [value]="prijavnicaForm.value.predlagEmail || 'Nema podataka'" type="text" />
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Godina osnutka:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagGodOsnut || 'Nema podataka'" type="number" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Cilj osnivanja:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagCiljOsnivanja || 'Nema podataka'" type="text" />
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Broj zaposlenih osoba čija se plaća sufinancira sredstvima iz projekta/programa:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagBrZaposleni || 'Nema podataka'" type="number" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Broj volontera uključenih u provedbu projekta/programa:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagBrVolonteri || 'Nema podataka'" type="number" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Ukupan broj osoba koje će primiti naknadu iz sredstava projekta:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagBrOsobaNak || 'Nema podataka'" type="number" />
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Prihodi u prošloj godini:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagPrihodi || 'Nema podataka'" type="text"
                  style="text-align: right;" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Godine dobivenih donacija:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagGodDonacija || 'Nema podataka'" />
              </div>
            </div>



            <div class="row" style="margin-bottom: 20px;">

              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Naziv projekta:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.projektNaziv || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Sažeti opis projekta/programa rada:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <textarea style="width:100% ; border: 1px solid #ccc;" id="projektOpis"
                  [value]="prijavnicaForm.value.projektOpis || 'Nema podataka'" type="text" rows="5" maxlength="200"
                  readonly>

</textarea>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Geografsko područje provedbe:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.projektGeoPodr || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Izvor sredstava za provedbu projekta/programa rada:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.projektSredstva || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Iznos koji se traži od HEP d.d.:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.projektIznosHep || 'Nema podataka'" type="text"
                  style="text-align: right;" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Ukupan iznos potreban za provedbu projekta/programa rada:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.projektIznos || 'Nema podataka'" type="text"
                  style="text-align: right;" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Osoba odgovorna za provedbu projekta/programa rada:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.projektOdgOs || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Na koji način ste ustvrdili postojanje problema:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <textarea style="width:100% ; border: 1px solid #ccc;" readonly
                  [value]="prijavnicaForm.value.projektProblem || 'Nema podataka'" type="text" rows="5">
</textarea>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Navedite ciljeve koji se postižu provođenjem predloženog projekta/programa rada:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <textarea style="width:100% ; border: 1px solid #ccc;" readonly
                  [value]="prijavnicaForm.value.projektCilj || 'Nema podataka'" type="text" rows="5">
</textarea>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Opišite rezultate koje očekujete po završetku projekta/programa rada:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <textarea style="width:100% ; border: 1px solid #ccc;" readonly
                  [value]="prijavnicaForm.value.projektRezultati || 'Nema podataka'" type="text" rows="5">
</textarea>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Aktivnosti provedbe projekta/programa rada - popis aktivnosti, nositelji, trajanje:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <textarea style="width:100% ; border: 1px solid #ccc;" readonly
                  [value]="prijavnicaForm.value.projektAktivnosti || 'Nema podataka'" type="text" rows="5">
</textarea>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Korisnici projekta/programa rada - broj i struktura:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <textarea style="width:100% ; border: 1px solid #ccc;" readonly
                  [value]="prijavnicaForm.value.projektKorisnici || 'Nema podataka'" type="text" rows="5">
</textarea>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Praćenje provedbe i vrednovanje uspješnosti provedbe:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <textarea style="width:100% ; border: 1px solid #ccc;" readonly
                  [value]="prijavnicaForm.value.projektPracenje || 'Nema podataka'" type="text" rows="5">
</textarea>
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Kontakt osoba prijavitelja:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagodgKontaktOs || 'Nema podataka'" type="text" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>Tel/mob. kontakt osobe:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagodgTel || 'Nema podataka'" type="number" />
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label>E-mail kontakt osobe*</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="prijavnicaForm.value.predlagodgEmail || 'Nema podataka'" type="text" />
              </div>
            </div>


            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label for="obrazacProracuna">Obrazac proračuna programa/projekta:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="selectedFile1?.name || 'Nema podataka'">
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label for="dokazRegistarNadl">Dokaz o registraciji:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="selectedFile2?.name || 'Nema podataka'">
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label for="dokazRegistarNeprofit">Dokaz o upisu u registar neprofitnih organizacija:
                </label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="selectedFile6?.name || 'Nema podataka'">
              </div>
            </div>


            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label for="potvrdaPorezna">Potvrda Porezne uprave o plaćenim doprinosima i porezima:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="selectedFile3?.name || 'Nema podataka'">
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label for="uvjerenjeNekaz">Uvjerenje da se ne vodi kazneni postupak:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="selectedFile4?.name || 'Nema podataka'">
              </div>
            </div>


            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label for="izjavaOsnova">Izjava o nepostojanju osnove za zabranu dodjele donacije:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="selectedFile5?.name || 'Nema podataka'">
              </div>
            </div>


            <div class="row" style="margin-bottom: 20px;">
              <div class="col-md-6 col-sm-12" class="pregledprijave">
                <label for="dokumentiOstalo">Ostali dokumenti:</label>
              </div>
              <div class="col-md-6 col-sm-12">
                <input readonly [value]="selectedFile7?.name || 'Nema podataka'">
              </div>
            </div>


            <!-- CAPTCHA Verification -->
            <!-- CAPTCHA Verification -->



            <div class="captcha-wrapper">
              <div class="captcha-grid">
                <!-- red 1: label + captcha kod + refresh -->
                <label for="captchaInput" class="captcha-label">Potvrdite da niste robot*:</label>

                <div class="captcha-code-row">

                  <div class="captcha-code">{{ captchaText }}</div>
                  <button type="button" class="refresh-icon-btn" style="background-color: #0e5996;color:white"
                    (click)="generateCaptcha()" aria-label="Osvježi CAPTCHA">
                    <em class="bi bi-arrow-clockwise"></em>
                  </button>


                </div>
                <div *ngIf="captchaError" class="captcha-error">
                  {{ emptyCaptchaError ? 'Unesite CAPTCHA kod.' : 'CAPTCHA nije ispravna. Osvježite i pokušajte
                  ponovno.' }}
                </div>
                <!-- red 2: unos -->
                <div class="captcha-input-row">
                  <!-- <span class="captcha-instruction">Unesite znakove sa slike</span> -->

                  <div class="captcha-input-wrap">
                    <input id="captchaInput" type="text" class="form-control" [(ngModel)]="userInput"
                      (input)="verifyCaptcha()" (copy)="disableCopyPaste($event)" (paste)="disableCopyPaste($event)"
                      (cut)="disableCopyPaste($event)" placeholder="Unesite znakove sa slike" />
                  </div>
                </div>

                <!-- red 3: error -->

                <div class="captcha-paznja">
                  Obratite pažnju na točan unos:
                  <strong>velika/mala slova</strong> i <strong>razmake</strong>
                </div>

              </div>
            </div>



            <div class="modal-footer">
              <button class="buttonmodal close-button" (click)="closePreview()">Zatvori</button>
              <!-- data-toggle="modal" data-target="#exampleModal" -->
              <!-- <button class="buttonmodal"   (click)="onSubmit()">
            Pošalji
          </button> -->
              <button class="buttonmodal" (click)="openConfirmModal()" [disabled]="isLoading">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span> Pošalji
              </button>
            </div>

          </div>

          <!-- </div>  -->
          <!-- Modal -->

        </div>
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
          aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">

              </div>
              <div class="modal-body" style="  border-top: none">
                Jeste li sigurni da želite poslati prijavu?
                <div class="modal-footer" style="border-color:transparent;  margin-top: 30px;">
                  <button type="button" class="buttonodustani" style="border-radius:0" data-dismiss="modal"
                    [disabled]="isLoading">Odustani</button>
                  <button class="buttonmodal" type="submit" (click)="onSubmit()" [disabled]="isLoading">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span> Pošalji
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <!-- <footer>
                <p>Hrvatska elektroprivreda d.d. <span style="color: #c62828;">|</span> Ulica grada Vukovara 37
                    <span style="color: #c62828;">|</span> 10 000 Zagreb</p>
            </footer> -->
    </div>
  </div>
</div>
